import { Button, Card, Col, DatePicker, Form, Input, Row, Select, Space } from "antd"
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons"
import type React from "react"
import { useEffect } from "react"
import type { EmailLogQueryParams } from "@/services/log/emailLogApi"
import dayjs from "dayjs"

const { RangePicker } = DatePicker

interface EmailFilterFormProps {
  onSearch: (values: EmailLogQueryParams) => void
  loading?: boolean
  initialValues?: EmailLogQueryParams
}

const emailTypeOptions = [
  { label: "Xác minh email", value: "verify_email" },
  { label: "Nhắc nhở học tập", value: "study_reminder" },
  { label: "Khác", value: "other" },
]

const statusOptions = [
  { label: "Gửi thành công", value: "sent" },
  { label: "Thất bại", value: "failed" },
]

export const EmailFilterForm: React.FC<EmailFilterFormProps> = ({
  onSearch,
  loading = false,
  initialValues,
}) => {
  const [form] = Form.useForm()

  useEffect(() => {
    form.setFieldsValue({
      search: initialValues?.search,
      email_type: initialValues?.email_type,
      status: initialValues?.status,
      dates:
        initialValues?.start_date && initialValues?.end_date
          ? [dayjs(initialValues.start_date), dayjs(initialValues.end_date)]
          : undefined,
    })
  }, [initialValues, form])

  const handleFinish = (values: any) => {
    const { dates, ...rest } = values
    const queryParams: EmailLogQueryParams = {
      ...rest,
      start_date: dates && dates[0] ? dayjs(dates[0]).format("YYYY-MM-DD") : undefined,
      end_date: dates && dates[1] ? dayjs(dates[1]).format("YYYY-MM-DD") : undefined,
    }
    onSearch(queryParams)
  }

  const handleReset = () => {
    form.resetFields()
    onSearch({})
  }

  return (
    <Card className="shadow-xs mb-2">
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        initialValues={{
          search: initialValues?.search,
          email_type: initialValues?.email_type,
          status: initialValues?.status,
          dates:
            initialValues?.start_date && initialValues?.end_date
              ? [dayjs(initialValues.start_date), dayjs(initialValues.end_date)]
              : undefined,
        }}
      >
        <Row gutter={[16, 8]}>
          <Col xs={24} sm={12} md={8}>
            <Form.Item label="Tìm kiếm (Email, Tiêu đề, Message ID hoặc #ID)" name="search">
              <Input placeholder="Nhập email, tiêu đề, ID..." allowClear />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5}>
            <Form.Item label="Loại email" name="email_type">
              <Select
                placeholder="Tất cả loại"
                allowClear
                options={emailTypeOptions}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4}>
            <Form.Item label="Trạng thái" name="status">
              <Select
                placeholder="Tất cả trạng thái"
                allowClear
                options={statusOptions}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={7}>
            <Form.Item label="Thời gian gửi" name="dates">
              <RangePicker
                className="w-full"
                placeholder={["Từ ngày", "Đến ngày"]}
                format="DD/MM/YYYY"
              />
            </Form.Item>
          </Col>

          <Col xs={24} className="flex justify-end">
            <Space>
              <Button icon={<ReloadOutlined />} onClick={handleReset}>
                Đặt lại
              </Button>
              <Button type="primary" htmlType="submit" icon={<SearchOutlined />} loading={loading}>
                Tìm kiếm
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Card>
  )
}

export default EmailFilterForm
